export default {
	'errors.providePhoneNumber': 'Please enter a valid phone number.',
	'errors.provideValidResponses': 'Please provide valid responses for all required fields.'
};


// WEBPACK FOOTER //
// ./~/@workmarket/translation/dist-es/messages/en-us/errors.js